import React from 'react';

const CaretIcon = ({ width = 10, height = 5, fill = '#7B7979' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0L5 5L10 0H0Z" fill={fill} />
    </svg>
  );
};

export default CaretIcon;
